import { fromJS } from 'immutable'
import {
  CONSENT_MANAGEMENT_EDIT_REQUEST,
  CONSENT_MANAGEMENT_EDIT_SUCCESS,
  CONSENT_MANAGEMENT_EDIT_FAILURE,
  CONSENT_MANAGEMENT_EDIT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case CONSENT_MANAGEMENT_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case CONSENT_MANAGEMENT_EDIT_SUCCESS:
      return state
        .set('consentEdit', fromJS(action.payload.updatedConsent))
        .set('status', 200)
        .set('message', 'Edited Successfully.')
        .set('isFetching', false)
    case CONSENT_MANAGEMENT_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('consentEdit', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case CONSENT_MANAGEMENT_EDIT_RESET:
      return state
        .delete('consentEdit')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/consent-management/consent-management-edit-reducer.js